<template>
	<vueper-slides :infinite="true" :bullets="false" class="no-shadow" :visible-slides="4" slide-multiple :gap="4" :autoplay="true" :breakpoints="slideConfig">
		<vueper-slide v-for="(item, index) in slides" :key="name + '-' + item.id">
			<template #content>
				<slot :item="slides[index]"></slot>
			</template>
		</vueper-slide>
	</vueper-slides>
</template>

<script>
	export default {
		props: ['name', 'slides'],
		computed: {
			slideConfig() {
				return {
					1080: {
						visibleSlides: 3,
						gap: 3
					},
					850: {
						visibleSlides: 2,
						gap: 2
					},
					600: {
						visibleSlides: 1,
						gap: 1,
						arrowsOutside: true
					}
				};
			}
		}
	}
</script>